import { useUser } from "@clerk/clerk-react";
import { Outlet } from "react-router-dom";

/**
 * ProtectedRoute simplifié avec la nouvelle API Clerk
 * SignedIn/SignedOut gère déjà l'authentification dans AppRoutes
 * Ce composant ne gère plus que les états de chargement
 */
const ProtectedRoute = () => {
  const { isLoaded } = useUser();

  // Afficher un loader pendant le chargement
  if (!isLoaded) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}>
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  // Si chargé, afficher les routes enfants
  // Note: SignedIn dans AppRoutes garantit déjà l'authentification
  return <Outlet />;
};

export default ProtectedRoute;